import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

/**
 * Slider component
 */
export default class Slider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    refs: ['slider', 'prev', 'next', 'pagination'],
    options: {
      pagination: {
        type: String,
        default: 'bullets',
      },
      spaceBetween: {
        type: Number,
        default: 0,
      },
      slidesPerView: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: this.$options.spaceBetween,
      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev,
      },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
        type: this.$options.pagination,
      },
      breakpoints: {
        480: {
          slidesPerView: 2, // Feel free to change this value !
        },
        640: {
          slidesPerView: 3, // Feel free to change this value !
        },
        1024: {
          slidesPerView: this.$options.slidesPerView > 0 ? this.$options.slidesPerView : 'auto',
        },
      },
    });
  }
}
